import Vue from "vue";

Vue.mixin({
  methods: {
    getNextRow(element) {
      let parentNode = element;
      let nextSibling;
      while (true) {
        parentNode = parentNode.parentNode;
        nextSibling = parentNode.nextSibling;
        while (nextSibling) {
          const tagName = nextSibling.tagName;
          if (tagName && tagName.toLowerCase() !== "hr") {
            break;
          }
          nextSibling = nextSibling.nextSibling;
        }
        if (nextSibling) {
          break;
        }
      }
      return nextSibling;
    },
    onMultiselectOpen(event) {
      if (event && event.target) {
        event.target.classList.add('multiselect--active');
      }
    },
    onMultiselectClose(event) {
      if (event && event.target) {
        if (event.target.classList) {
          event.target.classList.remove('multiselect--active');
        }
      }
    },
  }
});



// WEBPACK FOOTER //
// ./src/mixins/html-element-handling.js